export default [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['code-block'],
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']                                         // remove formatting button
];